export default function (context) {
    context.items = [];
}